import { get, chain, replace } from "lodash"
import { createSelector } from "reselect"
import { getAlphaTheoryStatus as getAlphaTheoryStatusRaw } from "modules/alpha-theory/selectors"
import { getEzeStatus as getEzeStatusRaw } from "modules/eze/selectors"
import { STATUSES, INTEGRATIONS } from "modules/platform/constants"
import { getIsOpPro } from "modules/account-root/selectors"

function insertBoldedLegalName(terms, accountMeta) {
  return replace(terms, "$legalName", `**${accountMeta.legalName}**`)
}

export const getIsSuperuser = state => get(state, "user.isSuperuser", false)
export const getAccountApiAccess = state => get(state, "global.selected.accountMeta.api", false)
export const getApplications = state => get(state, "global.data.applications.data")
export const getIntegrations = state => get(state, "global.data.integrations.data")
const getAccountMeta = (state) => get(state, "global.selected.accountMeta")

const getEzeRequested = state => get(state, "modules.platform.ezeIntegrationRequested")
const getEzeTermsRaw = (state) => get(state, "global.data.ezeTerms.data.value")
export const getEzeTermsVersion = (state) => get(state, "global.data.ezeTerms.data.version")

const getAiTermsRaw = (state) => get(state, "global.data.aiTerms.data.value")
export const getAiTermsVersion = (state) => get(state, "global.data.aiTerms.data.version")

const getAtRequested = state => get(state, "modules.platform.atIntegrationRequested")
const getAlphaTheoryTermsRaw = (state) => get(state, "global.data.atTerms.data.value")
export const getAlphaTheoryTermsVersion = (state) => get(state, "global.data.atTerms.data.version")
export const getPartnerTerms = (state) => get(state, "global.data.partnerTerms.data")

export const getAlphaTheoryStatus = createSelector(
  [getAtRequested, getAlphaTheoryStatusRaw],
  (requested, status) => status === STATUSES.NONE && requested ? STATUSES.REQUESTED : status,
)

export const getATTerms = createSelector(
  [getAlphaTheoryTermsRaw, getAccountMeta],
  insertBoldedLegalName,
)

export const getEzeStatus = createSelector(
  [getEzeRequested, getEzeStatusRaw],
  (requested, status) => status === STATUSES.NONE && requested ? STATUSES.REQUESTED : status,
)

export const getEzeTerms = createSelector(
  [getEzeTermsRaw, getAccountMeta],
  insertBoldedLegalName,
)

export const getAiTerms = createSelector(
  [getAiTermsRaw, getAccountMeta],
  insertBoldedLegalName,
)

export const getAiPermissionGranted = state => get(state, "modules.platform.aiPermissionGranted")

// Integrations need to be sorted, but they are disparate data structures
// "type" is used to render the correct component for each integration
export const getSortedIntegrations = createSelector(
  [getIntegrations, getIsOpPro],
  (integrations, isOpPro) => chain([
    ...integrations.map(i => ({ ...i, type: i.isGenericPartner ? INTEGRATIONS.GENERIC : INTEGRATIONS.PARTNER })),
    { type: INTEGRATIONS.ALPHA_THEORY, name: "Alpha Theory" },
    { type: INTEGRATIONS.EZE, name: "SS&C Eze" },
    !isOpPro && { type: INTEGRATIONS.OMPNT_AI, name: "Omega Point Artificial Intelligence" },
  ])
    .compact()
    .orderBy(i => i.name)
    .value(),
)
